import { Component, inject } from '@angular/core'
import { RouterLink } from '@angular/router'

import { TranslatePipe } from '@ngx-translate/core'

import { FeatureFlag } from '../../../environments/environment.interface'
import { FeatureFlagService } from '../../services/feature-flag.service'

interface NavigationItem {
  label: string
  link: string
}

interface NavigationSection {
  title: string
  items: NavigationItem[]
}

@Component({
  selector: 'dhp-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.scss'],
  imports: [RouterLink, TranslatePipe],
})
export class FooterComponent {
  private readonly featureFlagService = inject(FeatureFlagService)

  currentYear: number = new Date().getFullYear()

  navigationSections: NavigationSection[] = [
    {
      title: 'denHollander',
      items: [
        { label: 'library', link: '/' },
        { label: 'editors', link: '/editors' },
        { label: 'authors', link: '/authors' },
        { label: 'subscribe', link: '/pricing' },
      ],
    },
    {
      title: 'products',
      items: [
        { label: 'magazines', link: '/magazines' },
        { label: 'packages', link: '/pricing' },
      ],
    },
    {
      title: 'company',
      items: [
        { label: 'aboutUs', link: '/about-us' },
        { label: 'helpAndSupport', link: '/help' },
        { label: 'contact', link: '/contact' },
      ],
    },
  ]

  bottomLinks: NavigationItem[] = [
    { label: 'privacy-policy', link: '/privacy-policy' },
    { label: 'terms-and-conditions', link: '/terms-and-conditions' },
    { label: 'data-mining', link: '/data-mining' },
    { label: 'cookie-settings', link: '/cookie-settings' },
  ]

  constructor() {
    const featureFlagService = this.featureFlagService

    if (featureFlagService.isEnabled(FeatureFlag.DEMO_PAGE)) {
      this.bottomLinks.unshift({
        label: 'demo',
        link: '/demo',
      })
    }
  }

  getItemLink(item: string): string {
    return (
      this.navigationSections
        .flatMap(section => section.items)
        .find(navItem => navItem.label === item)?.link ?? '/'
    )
  }
}
